import { render, staticRenderFns } from "./declarationCodeModal.vue?vue&type=template&id=77243bde&"
import script from "./declarationCodeModal.vue?vue&type=script&lang=js&"
export * from "./declarationCodeModal.vue?vue&type=script&lang=js&"
import style0 from "./declarationCodeModal.vue?vue&type=style&index=0&id=77243bde&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports